import { defineMessages } from 'react-intl';

export const AiWizardMessages = defineMessages({
  header: {
    id: 'administration.tab.aiWizard.header',
    defaultMessage: 'AI Advisory Settings',
  },

  // AI Features Toggle
  aiFeaturesToggleLabel: {
    id: 'administration.tab.aiWizard.aiFeaturesToggleLabel',
    defaultMessage: 'Enable AI Features',
  },
  aiFeaturesToggleDescription: {
    id: 'administration.tab.aiWizard.aiFeaturesToggleDescription',
    defaultMessage:
      'Toggle to enable or disable AI features including the AI Advisory tab in the sidebar.',
  },
  aiEnabled: {
    id: 'administration.tab.aiWizard.aiEnabled',
    defaultMessage: 'Enabled',
  },
  aiDisabled: {
    id: 'administration.tab.aiWizard.aiDisabled',
    defaultMessage: 'Disabled',
  },

  // AI Instructions
  aiInstructionsLabel: {
    id: 'administration.tab.aiWizard.aiInstructionsLabel',
    defaultMessage: 'Tenant Instructions',
  },
  aiInstructionsPlaceholder: {
    id: 'administration.tab.aiWizard.aiInstructionsPlaceholder',
    defaultMessage:
      'Enter specific instructions for the AI assistant to follow when helping users in this tenant...',
  },
  aiInstructionsDescription: {
    id: 'administration.tab.aiWizard.aiInstructionsDescription',
    defaultMessage:
      "Provide context-specific instructions that will help the AI assistant better understand your organization's processes, terminology, and requirements.",
  },

  // AI Instructions Custom Translation Key (used for storing per-language instructions)
  aiInstructionsCustomTranslationKey: {
    id: 'aiAdvisory.tenantInstructions',
    defaultMessage: '',
  },

  // Advisory default model (EWM-1087)
  advisoryDefaultModelLabel: {
    id: 'administration.tab.aiWizard.advisoryDefaultModelLabel',
    defaultMessage: 'Default Estimation Model',
  },
  advisoryDefaultModelDescription: {
    id: 'administration.tab.aiWizard.advisoryDefaultModelDescription',
    defaultMessage:
      'Preselected on the Convert to Estimation page. Leave empty to use the seeded AI Advisory model.',
  },
  advisoryDefaultModelPlaceholder: {
    id: 'administration.tab.aiWizard.advisoryDefaultModelPlaceholder',
    defaultMessage: 'Use the seeded AI Advisory model',
  },

  // Prompt ID
  promptIdLabel: {
    id: 'administration.tab.aiWizard.promptIdLabel',
    defaultMessage: 'Prompt ID',
  },
  promptIdPlaceholder: {
    id: 'administration.tab.aiWizard.promptIdPlaceholder',
    defaultMessage: 'Enter the prompt ID...',
  },
  promptIdDescription: {
    id: 'administration.tab.aiWizard.promptIdDescription',
    defaultMessage:
      'The unique identifier for the AI prompt template. Leave empty to use the system default.',
  },

  // Prompt Version
  promptVersionLabel: {
    id: 'administration.tab.aiWizard.promptVersionLabel',
    defaultMessage: 'Prompt Version',
  },
  promptVersionPlaceholder: {
    id: 'administration.tab.aiWizard.promptVersionPlaceholder',
    defaultMessage: 'Enter the prompt version...',
  },
  promptVersionDescription: {
    id: 'administration.tab.aiWizard.promptVersionDescription',
    defaultMessage: 'The version of the prompt template. Leave empty to use the latest version.',
  },

  // API Key
  apiKeyLabel: {
    id: 'administration.tab.aiWizard.apiKeyLabel',
    defaultMessage: 'API Key',
  },
  apiKeyPlaceholder: {
    id: 'administration.tab.aiWizard.apiKeyPlaceholder',
    defaultMessage: 'Enter your API key...',
  },
  apiKeyDescription: {
    id: 'administration.tab.aiWizard.apiKeyDescription',
    defaultMessage:
      'Optional: Provide a custom API key for this tenant. Leave empty to use the system default.',
  },

  // Organization ID
  organizationIdLabel: {
    id: 'administration.tab.aiWizard.organizationIdLabel',
    defaultMessage: 'Organization ID',
  },
  organizationIdPlaceholder: {
    id: 'administration.tab.aiWizard.organizationIdPlaceholder',
    defaultMessage: 'Enter your OpenAI organization ID...',
  },
  organizationIdDescription: {
    id: 'administration.tab.aiWizard.organizationIdDescription',
    defaultMessage:
      'Optional: Provide a custom organization ID for this tenant. Leave empty to use the system default.',
  },

  // Project ID
  projectIdLabel: {
    id: 'administration.tab.aiWizard.projectIdLabel',
    defaultMessage: 'Project ID',
  },
  projectIdPlaceholder: {
    id: 'administration.tab.aiWizard.projectIdPlaceholder',
    defaultMessage: 'Enter your OpenAI project ID...',
  },
  projectIdDescription: {
    id: 'administration.tab.aiWizard.projectIdDescription',
    defaultMessage:
      'Optional: Provide a custom project ID for this tenant. Leave empty to use the system default.',
  },

  // API Messages
  apiSaveDataSuccess: {
    id: 'administration.tab.aiWizard.apiSaveDataSuccess',
    defaultMessage: 'AI Advisory settings successfully saved',
  },
  apiSaveDataError: {
    id: 'administration.tab.aiWizard.apiSaveDataError',
    defaultMessage: 'Failed to save AI Advisory settings. Please try again.',
  },

  // Test Connection
  testConnectionButton: {
    id: 'administration.tab.aiWizard.testConnectionButton',
    defaultMessage: 'Test Connection',
  },
  testConnectionSuccess: {
    id: 'administration.tab.aiWizard.testConnectionSuccess',
    defaultMessage: 'Connection test successful! The AI configuration is working correctly.',
  },
  testConnectionError: {
    id: 'administration.tab.aiWizard.testConnectionError',
    defaultMessage: 'Connection test failed. Please check your configuration.',
  },
  testConnectionTesting: {
    id: 'administration.tab.aiWizard.testConnectionTesting',
    defaultMessage: 'Testing connection...',
  },
});
